import React from "react";
import { useQuery, gql } from "@apollo/client";
import { useParams } from "react-router-dom";
import {
  makeStyles,
  colors,
  Box,
  Card,
  CardContent,
  CircularProgress,
  Grid,
  Typography,
  List,
  ListItem,
  ListItemAvatar,
  ListItemText,
  Avatar,
} from "@material-ui/core";

const GET_COLLEGE_INFO = gql`
  query Query($getCollegeInfoCollegeId: String) {
    getCollegeInfo(collegeId: $getCollegeInfoCollegeId)
  }
`;

const useStyle = makeStyles((theme) => ({
  green: {
    color: theme.palette.getContrastText(colors.green[400]),
    backgroundColor: colors.green[400],
  },
}));

export function Grades() {
  const { collegeId } = useParams();
  const classes = useStyle();

  const { loading, error, data } = useQuery(GET_COLLEGE_INFO, {
    fetchPolicy: "cache-first",
    variables: {
      getCollegeInfoCollegeId: collegeId,
    },
  });

  if (loading) {
    return (
      <Box>
        <CircularProgress style={{ color: "#3699FF" }} />
      </Box>
    );
  }

  let collegeDetails = !error ? JSON.parse(data.getCollegeInfo) : {};

  const gradeKeys = Object.keys(collegeDetails).filter((key) =>
    key.startsWith("rankings")
  );

  console.log(collegeDetails[gradeKeys[0]]);

  return (
    <>
      <Card className="mb-5">
        <CardContent>
          <Typography variant="h4" className="text-center" color="primary">
            {collegeDetails.name + " Grades"}
          </Typography>
        </CardContent>
      </Card>

      <Card className="mb-5">
        <CardContent>
          <Grid container spacing={8} justify="center">
            <Grid item sm={4}>
              <List>
                {gradeKeys
                  .slice(0, Math.ceil(gradeKeys.length / 2))
                  .map((key, index) => (
                    <ListItem key={index}>
                      <ListItemAvatar>
                        <Avatar className={classes.green}>
                          {getGradeFromRanking(collegeDetails[key])}
                        </Avatar>
                      </ListItemAvatar>
                      <ListItemText>{collegeDetails[key].name}</ListItemText>
                    </ListItem>
                  ))}
              </List>
            </Grid>
            <Grid item sm={4}>
              <List>
                {gradeKeys
                  .slice(Math.ceil(gradeKeys.length / 2))
                  .map((key, index) => (
                    <ListItem key={index}>
                      <ListItemAvatar>
                        <Avatar className={classes.green}>
                          {getGradeFromRanking(collegeDetails[key])}
                        </Avatar>
                      </ListItemAvatar>
                      <ListItemText>{collegeDetails[key].name}</ListItemText>
                    </ListItem>
                  ))}
              </List>
            </Grid>
          </Grid>
        </CardContent>
      </Card>
    </>
  );
}

function getGradeFromRanking({ value, total }) {
  let score;
  if (!value || !total) {
    score = -1;
  }

  score = (1 - value / total) * 40 + 60;
  let grade;
  if (score >= 90) {
    grade = "A";
  } else if (score >= 80 && score < 90) {
    grade = "B";
  } else if (score >= 70 && score < 80) {
    grade = "C";
  }
  if (score < 70) {
    grade = "?";
  } else if (score % 10 >= 7 || score === 100) {
    grade += "+";
  } else if (score % 10 <= 3) {
    grade += "-";
  }

  return grade;
}